export default __webpack_public_path__ + "static/media/residential_loans.fd0b598f.svg";